import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Papa from 'papaparse';
import { injectIntl, defineMessages } from 'react-intl';
import { getUserId } from '../../../helpers/cookies';
import service from './duck/service';
import formatter from 'pages/ScheduleCalendar/duck/formatter';

import FilterDataContainer from 'components/CalendarComponents/FilterContainer/FilterDataContainer';
import styledConfirm from '../../Requests/components/styled';
import UpgradePrompt from '../../../components/GeneralComponents/UpgradePrompt/UpgradePrompt';
import Modal from 'components/GeneralComponents/Modal';
import { createCsvRowData2, } from 'helpers/formatting';
import {
  CalendarCsvHeaders,
  CsvExportHeadersWithSkills,
  CalendarTableHeadersWithSkills,
  CalendarTableHeaders,
  CalendarShiftTypes,
} from 'config';
import { shiftDuration, createCsvDateFormat, startOfLocationFiscalWeek, endOfLocationFiscalWeek } from '../../../helpers/date-time';
import { CALENDAR_SHIFTS_PER_PAGE, MAX_LOADING_TIMES } from 'constants/index';

import './ShiftRecordsPage.scss';
import ShiftRecordsTable from 'pages/RequestsTab/ShiftRecords/ShiftRecordsTable';

const sha1 = require('js-sha1');

class ShiftRecordsPage extends React.Component {
  constructor(props) {
    super(props);

    this.mqttClient = props.mqttClient;
    this.mqttTopic = `user_event/${sha1(`user.${getUserId()}`)}`;
    this._messageHandler = null;

    this.messages = defineMessages({
      notApplicable: {
        id: 'ShiftRecordsPage',
        defaultMessage: 'N/A',
        description: "Placeholder when data for column doesn't exist",
      },
    });

    this.state = {
      headers: null,
      csvHeaders: null,
      skills: null,
      deletedGroupId: null,
      timer: null,
      planName: '',
      displayedDateRangeStart: null,
      displayedDateRangeEnd: null,
    };

    this._isMounted = false;
    this.pageIndex = 1;
    this.stopLoading = false;
    this.timeOutCount = 0;
  }

  componentDidMount() {
    const { allUsers, locationSettings, skills, locationId, getLocationUsableSkills, plans, locationData, getScheduleUsers } = this.props;

    this._isMounted = true;
    this.mqttSubscribe();

    const myTimer = setInterval(this.tick, 1000); //unit: ms, 1000 = 1 second
    this.setState({ timer: myTimer });

    if (locationSettings && locationSettings.cfg__skill === 1 ) {
      this.setState({ headers: CalendarTableHeadersWithSkills });
      this.setState({ csvHeaders: CsvExportHeadersWithSkills });
    } else {
      this.setState({ headers: CalendarTableHeaders });
      this.setState({ csvHeaders: CalendarCsvHeaders });
    }

    if (locationId) {
      getLocationUsableSkills(locationId);
      if( allUsers == null || allUsers.length == 0){
        getScheduleUsers(locationId, 1, 10000)
      }
    }

    if (skills && skills.length > 0) {
      if (this._isMounted) {
        this.setState({ skills: skills });
      }
    }

    if (plans && plans.length > 0) {
      if (locationData && locationData.plan_id) {
        const cplan = plans.find(plan => plan.id === locationData.plan_id);
        this.setState({ planName: cplan.name });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { shifts, skills,  dateStart, dateEnd, locationId, plans, locationData, getApplicantsForShiftsDispatch } = this.props;

    if (prevProps.skills !== skills) {
      if (skills && skills.length > 0) {
        if (this._isMounted) {
          this.setState({ skills: skills });
        }
      }
    }
    if (prevProps.locationData !== locationData) {
      if (plans && plans.length > 0) {
        if (locationData && locationData.plan_id) {
          const cplan = plans.find(plan => plan.id === locationData.plan_id);
          this.setState({ planName: cplan.name });
        }
      }

      if (!this.apiCalled && locationData !== null) {
        this.pageIndex = 1;
        this.makeLoadShiftsCall(dateStart, dateEnd, 'Initial Load');
      }

    } else if (prevProps.dateStart !== dateStart) {
      if (this.apiCalled) {
        this.pageIndex = 1;
        this.makeLoadShiftsCall(dateStart, dateEnd, 'Week Range Change');
      }
    } else if (prevProps.shifts !== shifts) {
      this.apiCalled = true;

      if (prevProps.shifts && shifts) {
        if (shifts.length - prevProps.shifts.length === CALENDAR_SHIFTS_PER_PAGE) {
          this.makeLoadShiftsCall(dateStart, dateEnd, 'Got More Shifts');
        }else if ( shifts.length !== prevProps.shifts.length ) {
          const applicantIDs = service.getApplicantIDsForShifts(shifts);
          console.log('Loading Applicants: ', applicantIDs);
          getApplicantsForShiftsDispatch(applicantIDs, locationId);
        }
      }
    }
  }

  makeLoadShiftsCall(dateStart, dateEnd, eventPrefix) {
    const { getMoreCalendarShiftsDispatch} = this.props;
    console.log(eventPrefix + '- Load Page:' + this.pageIndex + ' @ ' + dateStart.format("MMM Do YYYY") + '-' + dateEnd.format("MMM Do YYYY"));
    getMoreCalendarShiftsDispatch(dateStart, dateEnd, this.pageIndex, CALENDAR_SHIFTS_PER_PAGE);
    this.pageIndex += 1;
  }

  componentWillUnmount() {
    const { timer } = this.state;
    this._isMounted = false;

    if (this._messageHandler && this.mqttClient) {
      this.mqttClient.removeListener('message', this._messageHandler);
      this.mqttClient.unsubscribe(this.mqttTopic);
    }

    if (timer) {
      clearInterval(this.state.timer);
    }
  }

  mqttSubscribe = () => {
    if (!this.mqttClient) {
      console.warn('[ShiftRecordsPage] MQTT client not available, skipping subscribe');
      return;
    }

    this._messageHandler = (topic, payload) => {
      let message;
      try {
        message = JSON.parse(payload.toString());
      } catch (err) {
        console.error('[ShiftRecordsPage] Failed to parse MQTT message:', err);
        return;
      }

      if (
        message.receiver_id == getUserId() &&
        message.event === 'shift' &&
        message.crud === 'UPDATE'
      ) {
        console.log('[ShiftRecordsPage] shift update:', message);
      }
      if (
        message.receiver_id == getUserId() &&
        message.event === 'channel' &&
        message.crud === 'DELETE'
      ) {
        const msg = `Calendar page: Group (channel) ${message.tree_id} has been deleted.`;
        console.log(msg);
        this.setState({ deletedGroupId: message.tree_id });
      }
    };

    this.mqttClient.on('message', this._messageHandler);
    this.mqttClient.subscribe(this.mqttTopic);
  };

  findSkills = (skill_ids) => {
    const { skills, } = this.props;
    let textSkills = '';
    if (skill_ids && skill_ids.length > 0) {
      if (skills && skills.length > 0) {
        for (let i = 0; i < skill_ids.length; i++) {
          for (let j = 0; j < skills.length; j++) {
            if (skill_ids[i] === skills[j].id) {
              textSkills += `${skills[j].skill_content}, `;
            }
          }
        }
      }
    }
    return textSkills;
  }

  setCsvHeaders = () => {
    const { intl } = this.props;

    return this.state.csvHeaders.reduce((header, element, index) => {
      if (index + 1 === this.state.csvHeaders.length) {
        return (header += intl.formatMessage(element.title) + '\n');
      } else {
        return (header += intl.formatMessage(element.title) + ', ');
      }
    }, '');
  };

  buildCsvBody = (rows, headers) => {
    const { intl } = this.props;
    const notApplicableString = intl.formatMessage(this.messages.notApplicable);

    return Papa.unparse(
      rows.map((element) => {

        return element.map((element, index) => {
          switch (headers[index].type) {
            case 'user':
              const tmpName = formatter.getNameFromUser(element);
              return tmpName && tmpName.length > 0 ? tmpName : notApplicableString;

            case 'date':
              return element
                ? createCsvDateFormat(element)
                : notApplicableString;

            case 'time':
              return element
                ? createCsvDateFormat(element)
                : notApplicableString;

            case 'duration':
              return formatter.durationString(element[0], element[1]);

            case 'enum':
              if (element === 'shift') {
                return intl.formatMessage(CalendarShiftTypes.teamShift);
              }

              if (element === 'open_shift') {
                return intl.formatMessage(CalendarShiftTypes.openShift);
              }

              if (element === 'shift_vto') {
                return intl.formatMessage(CalendarShiftTypes.vto);
              }

              return (
                element.charAt(0).toUpperCase() + element.slice(1)
              ).replace(/_/g, ' ');
            case 'skills':
              return element ? this.findSkills(element) : ' '
              break
            default:
              return `${element}`;
          }
        });
      })
    );
  };

 exportData = (from, to, rowData, allUsers) => {

 const { location, applicantsDictionary} = this.props;
 const { csvHeaders } = this.state;

  if (!rowData.length) return;

  const formattedFrom = moment(from).format('YYYY-MM-DD');
  const formattedTo = moment(to).format('YYYY-MM-DD');
  const fileName = `${formattedFrom}-${formattedTo}.csv`;

  const csvData = createCsvRowData2(rowData, csvHeaders, location, allUsers, applicantsDictionary);

  console.log(csvData);

  const csvContent =
    `data:text/csv;charset=utf-8,` +
    this.setCsvHeaders() +
    this.buildCsvBody(csvData, csvHeaders)
  .replace(/#/g, '');

  if (navigator.msSaveBlob) {
    const blobContent = this.setCsvHeaders() + this.buildCsvBody(csvData, csvHeaders);
    const blob = new Blob([blobContent], { type: 'text/plain;charset=utf-8;' });
    return navigator.msSaveOrOpenBlob(blob, fileName);
  }

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', fileName);
  document.body.appendChild(link); // Required for Firefox
  return link.click();
};


  translateHeaders = () => {
    const { intl } = this.props;
    const { headers } = this.state;

    if (headers) {
      return headers.map((header) => ({
        ...header,
        title: intl.formatMessage(header.title),
      }));
    } else {
      return null;
    }

  };

  dateRangeChanged = (start, end) => {
    this.pageIndex = 1;
    this.stopLoading = false;
    this.setState({ displayedDateRangeStart: start, displayedDateRangeEnd: end });
  }

  notifyRefreshRequested = () => {
    const { refreshWeek } = this.props;
    const { displayedDateRangeStart, displayedDateRangeEnd } = this.state;
    if (displayedDateRangeStart && displayedDateRangeEnd) {
      refreshWeek(displayedDateRangeStart, displayedDateRangeEnd);
    }
  }

  render() {
    const { shifts, loading, locationSettings, stateFilters, locationId, allUsers, applicantsDictionary } = this.props;
    const { skills, deletedGroupId, planName, } = this.state;

    const shiftRecords = service.getShiftRecordRows(shifts, stateFilters, allUsers);
    // console.log(allUsers);

    return (
      <article>
        <FilterDataContainer
          exportData={this.exportData}
          dateRangeChanged={this.dateRangeChanged}
          shiftRecords = {shiftRecords}
          allUsers = {allUsers}
        />
       
        <ShiftRecordsTable
          shifts={shiftRecords}
          loading={loading}
          headers={this.translateHeaders()}
          locationSettings={locationSettings}
          skills={skills}
          notifyRefreshRequested={this.notifyRefreshRequested}
          stateFilters={stateFilters}
          deletedGroupId={deletedGroupId}
          locationId = {locationId}
          applicantsDictionary = {applicantsDictionary}
          enableVto={this.props.enableVto}
        />

        {planName === 'Basic' && <Modal>
          <UpgradePrompt />
        </Modal>}
        <styledConfirm.Overlay display={planName === 'Basic' ? 'block' : 'none'} />
      </article>
    );
  }
}

export default injectIntl(ShiftRecordsPage);

ShiftRecordsPage.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  loading: PropTypes.bool,
  mqttClient: PropTypes.object.isRequired,
};

ShiftRecordsPage.defaultProps = {
  headers: [],
  rows: [],
  loading: false,
};
